/* eslint class-methods-use-this: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { withLocaleContext } from 'providers/locale-settings-context';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Label from 'components/v2/forms/Label';
const DATE_FORMAT = 'L LT';
const TIME_FORMAT = 'LT';
const TOOLTIPS = {
    start: 'START_DATE_TIME_APPOINTMENT',
    end: 'END_DATE_TIME_APPOINTMENT',
};
class AppointmentPicker extends Component {
    renderConfirmAppointment() {
        const { start, end, confirmed, hideConfirm, t } = this.props;
        if (hideConfirm) {
            return null;
        }
        const confirmedDisabled = !start || !end;
        const confirmedChecked = !!start && !!end && confirmed;
        return (React.createElement("div", { "data-testid": "div-aa2ec80e", className: "flex flex-col items-center px-4" },
            React.createElement(Label, { dataTestId: "Label-e697c0dc", className: "mb-2" },
                t('CONFIRMED'),
                "?"),
            React.createElement("div", { "data-testid": "div-623d8ad0", className: "py-2" },
                React.createElement("input", { "data-testid": "input-3e50201a", type: "checkbox", checked: confirmedChecked, disabled: confirmedDisabled, onChange: (e) => this.props.onToggleConfirmed(e.target.checked) }))));
    }
    render() {
        const { start, end, t, languageCodeId, dataTestId } = this.props;
        return (React.createElement("div", { "data-testid": dataTestId },
            React.createElement("div", { "data-testid": "div-6418e50e", className: "flex -mx-8" },
                React.createElement("div", { "data-testid": "div-edbeb278", className: "px-4" },
                    React.createElement(Label, { dataTestId: "Label-bfd09a80", helptext: t(TOOLTIPS.start), className: "mb-2" }, t('WINDOW_START_WITH_TIMEZONE', {
                        timezone: moment.tz(this.props.selected_timezone).zoneAbbr(),
                    })),
                    React.createElement(DatePicker, { timeIntervals: 15, fixedHeight: true, className: "block form-field", placeholderText: this.props.startInputPlaceholder || t('START'), selected: start, onChange: (date) => this.props.onStartChange(date), onSelect: (date) => this.props.onStartChange(date), dateFormat: this.props.dateFormat || DATE_FORMAT, timeFormat: this.props.timeFormat || TIME_FORMAT, locale: this.props.locale || languageCodeId, isClearable: true, shouldCloseOnSelect: true, showTimeSelect: true })),
                React.createElement("div", { "data-testid": "div-89e3aee0", className: "px-4" },
                    React.createElement(Label, { dataTestId: "Label-26f11d7a", className: "mb-2", helptext: t(TOOLTIPS.end) }, t('WINDOW_END_WITH_TIMEZONE', {
                        timezone: moment.tz(this.props.selected_timezone).zoneAbbr(),
                    })),
                    React.createElement(DatePicker, { timeIntervals: 15, fixedHeight: true, className: "block form-field", placeholderText: this.props.endInputPlaceholder || t('END'), selected: end, onChange: (date) => this.props.onEndChange(date), onSelect: (date) => this.props.onEndChange(date), dateFormat: this.props.dateFormat || DATE_FORMAT, timeFormat: this.props.timeFormat || TIME_FORMAT, locale: this.props.locale || languageCodeId, isClearable: true, shouldCloseOnSelect: true, showTimeSelect: true })),
                this.renderConfirmAppointment())));
    }
}
AppointmentPicker.propTypes = {
    start: PropTypes.instanceOf(moment),
    end: PropTypes.instanceOf(moment),
    confirmed: PropTypes.bool,
    dateFormat: PropTypes.string,
    hideConfirm: PropTypes.bool,
    selected_timezone: PropTypes.string,
    startInputPlaceholder: PropTypes.string,
    endInputPlaceholder: PropTypes.string,
    onStartChange: PropTypes.func.isRequired,
    onEndChange: PropTypes.func.isRequired,
    onToggleConfirmed: PropTypes.func.isRequired,
};
export default withTranslation()(withLocaleContext(AppointmentPicker));
